<template>
  <vx-card no-shadow>
    <h2 class="mb-6">Modules</h2>

    <vs-table
      ref="table"
      class="mt-8"
      v-model="selected"
      pagination
      :max-items="itemsPerPage"
      search
      :data="modules"
      @selected="onModuleClicked(selected.moduleId)"
    >
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
          <!-- ADD NEW -->
          <div
            @click="$router.push({ name: 'admin-survey-add-new-online-training-module', params: { surveyId: surveyId } }).catch(() => {})"
            class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Add Module</span>
          </div>
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span
              class="mr-2"
            >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ modules.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : modules.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=40">
              <span>40</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=100">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="title">Title</vs-th>
        <vs-th sort-key="canRedoLessons">Can lessons be redone</vs-th>
        <vs-th sort-key="numLessons">Lessons</vs-th>
        <vs-th>Action</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-name font-medium truncate">{{ $translate(tr.title) }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.canRedoLessons | yesno }}</p>
            </vs-td>
            <vs-td>
              <vs-chip
                :color="getNumLessonsColor(tr.numLessons)"
                class="product-order-status"
              >{{ tr.numLessons }}</vs-chip>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon
                icon="EditIcon"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                @click.stop="editData(tr)"
              />
              <feather-icon
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click.stop="confirmDelete(tr.moduleId)"
              />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </vx-card>
</template>

<script>
export default {
  components: {},
  props: {
    item: Object,
  },
  data() {
    return {
      surveyId: "",

      query: "*",

      modules: [],

      selected: [],
      itemsPerPage: 100,
      isMounted: false,

      itemIdToDelete: null
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },

    queriedItems() {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.modules.length;
    },
  },
  methods: {
    getModules: function () {
      this.$vs.loading();

      const url =
        process.env.VUE_APP_API +
        "/Surveys/4/" +
        this.surveyId +
        "/modules?query=" +
        this.query;

      this.$http
        .get(url)
        .then((resp) => {
          console.log(resp.data);
          this.modules = resp.data;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    onModuleClicked(moduleId) {
      this.$router
        .push({
          name: "admin-survey-online-training-module",
          params: {
            surveyId: this.surveyId,
            moduleId: moduleId,
          },
        })
        .catch(() => {});
    },

    confirmDelete(itemId) {
      this.itemIdToDelete = itemId;

      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: `Confirm`,
        text: 'Are you sure you want to delete the Module?',
        accept: this.deleteItem
      })
      },
    deleteItem() {
      const url = process.env.VUE_APP_API +
        '/Surveys/' + 'OnlineTraining' + '/' + this.surveyId + 
        '/modules/' + this.itemIdToDelete;

      this.$http.delete(url)
        .then((/*resp*/) => {
          this.$vs.notify({
            color:'success',
            title:'Success',
            text:'Module deleted'
          });

         this.getModules();
        })
        .catch(err => {
          console.log(err)

          this.$vs.notify({
            color:'danger',
            title:'Error',
            text:'Could not delete Module: ' + err
          });
        })
        .finally(() => {
          this.$vs.loading.close()
        })
    },

    editData(data) {
      console.log("Edit:", data);
    },

    getNumLessonsColor(numLessons) {
      if (numLessons == 0) return "warning";
      return "success";
    },
    getStatusColor(status) {
      if (status === true) return "success";
      return "danger";
    },
  },
  created() {
    this.surveyId = this.$route.params.surveyId;
    this.getModules();
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>

<style lang="scss">
.status-category {
  display: flex;
  align-items: center;
}

.status-circle {
  width: 14px;
  height: 14px;
  min-width: 14px;
  min-height: 14px;
  margin-right: 5px;
}

.con-vs-dialog .vs-dialog {
  max-width: 600px;
}
</style>